import React from 'react';
import './ListScreenPaginationBar.css';

const DEFAULT_ENTRY_OPTIONS = [
  { value: '10', label: '10' },
  { value: '30', label: '30' },
  { value: '50', label: '50' },
  { value: 'all', label: 'All' }
];

/**
 * Bottom bar: Show [n] entries, optional left slot (e.g. Event Logs), Page [x] of [y].
 */
const ListScreenPaginationBar = ({
  entriesValue,
  onEntriesChange,
  entryOptions = DEFAULT_ENTRY_OPTIONS,
  leftSlot = null,
  showPageSelector = true,
  currentPage = 1,
  totalPages = 1,
  onPageChange
}) => {
  const safeTotal = Math.max(1, Number(totalPages) || 1);
  const rawPage = Number(currentPage) || 1;
  const safeCurrent = Math.min(Math.max(1, rawPage), safeTotal);
  const rawEv = entriesValue ?? '30';
  const selectValue =
    rawEv === 9999 || rawEv === '9999' || rawEv === 'all' || rawEv === 'All' ? 'all' : String(rawEv);

  return (
    <div className="list-screen-pagination-section">
      <div className="list-screen-pagination-left">
        <div className="list-screen-entries-selector">
          <span>Show</span>
          <select
            className="list-screen-entries-select"
            value={selectValue}
            onChange={(e) => onEntriesChange(e.target.value)}
          >
            {entryOptions.map((opt) => (
              <option key={String(opt.value)} value={String(opt.value)}>
                {opt.label ?? opt.value}
              </option>
            ))}
          </select>
          <span>entries</span>
        </div>
        {leftSlot}
      </div>
      {showPageSelector && (
        <div className="list-screen-pagination-right">
          <div className="list-screen-page-selector">
            <span>Page</span>
            <select
              className="list-screen-page-select"
              value={safeCurrent}
              onChange={(e) => onPageChange(parseInt(e.target.value, 10))}
            >
              {Array.from({ length: safeTotal }, (_, i) => i + 1).map((page) => (
                <option key={page} value={page}>
                  {page}
                </option>
              ))}
            </select>
            <span>of {safeTotal}</span>
          </div>
        </div>
      )}
    </div>
  );
};

export default ListScreenPaginationBar;
export { DEFAULT_ENTRY_OPTIONS };
